import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  ugDegreeList: {},
};

export const ugDegreeListSlice = createSlice({
  name: 'ugDegreeList',
  initialState,
  reducers: {
    setUgDegreeList: (state, action: PayloadAction<any>) => {
      state.ugDegreeList = action.payload;
    }
  },
});

export const { setUgDegreeList } = ugDegreeListSlice.actions;

export default ugDegreeListSlice.reducer;

